export var deliveryMethodImages = {
    SMS: 'https://wixmp-9127dea18607b759d29e6784.wixmp.com/badges/commentSmall.png',
    Chat: 'https://wixmp-9127dea18607b759d29e6784.wixmp.com/badges/chat2Small.png',
    Email: 'https://wixmp-9127dea18607b759d29e6784.wixmp.com/badges/mailSmallFlat.png',
    Facebook: 'https://wixmp-9127dea18607b759d29e6784.wixmp.com/badges/facebookSmall.png',
};
//# sourceMappingURL=delivery-method-images.js.map